import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-2" data-testid="language-switcher">
      <button
        onClick={() => setLanguage('no')}
        className={`transition-opacity ${language === 'no' ? 'opacity-100' : 'opacity-40 hover:opacity-70'}`}
        aria-label="Switch to Norwegian"
        data-testid="lang-no-btn"
      >
        <img 
          src="https://flagcdn.com/w40/no.png" 
          alt="Norwegian Flag" 
          className="w-6 h-4 object-cover"
        />
      </button>
      <button
        onClick={() => setLanguage('en')}
        className={`transition-opacity ${language === 'en' ? 'opacity-100' : 'opacity-40 hover:opacity-70'}`}
        aria-label="Switch to English"
        data-testid="lang-en-btn"
      >
        <img 
          src="https://flagcdn.com/w40/gb.png" 
          alt="English Flag" 
          className="w-6 h-4 object-cover"
        />
      </button>
    </div>
  );
};

export default LanguageSwitcher;